import { AppButton, AppTextField } from 'components';
import useToaster from 'hooks/useToaster';
import { useState, useEffect, useCallback, useContext } from 'react';
import { UserContext } from 'context/UserContext';
import BasicDelete from 'components/molecules/Modal/Delete/BasicDelete';
// import TablePaginate from '../../components/Paginate';
import useChapters from 'hooks/API/GET/useChapters';
import useChapterAdd from 'hooks/API/POST/useChapterAdd';
import { Link, useParams } from 'react-router-dom';
// import usePaginateDefaults from 'hooks/usePaginateDefaults';
import * as AppPics from 'assets/images';
import Joi from 'joi';
import { checkForErrors } from 'utilities/fns';
import useManageTopics from 'hooks/API/useManageTopics';
import { getRandomUid } from 'utilities/uuid.service';
import { ReactSortable } from 'react-sortablejs';
import useCloneChapter from 'hooks/API/POST/useCloneChapter';
// import useReOrderChapter from 'hooks/API/POST/useReOrderChapter';
// import useReOrderTopic from 'hooks/API/POST/useReOrderTopic';
import useReOrderChapterQuiz from 'hooks/API/POST/useReOrderChapterQuiz';
import DetailsHeader from 'components/molecules/DetailsHeader';
import useManageSubTopics from 'hooks/API/useManageSubTopics';
// import useCloneSubTopic from 'hooks/API/POST/useCloneSubTopic';
import useReOrderSubTopics from 'hooks/API/POST/useReOrderSubTopics';
import { AiOutlineEye } from 'react-icons/ai';
import useQueryParams from 'hooks/useQueryParams';
import CopyContentsModal from './CopyContentsModal';
import './perfrom-assess.css';
import useManageQuiz from 'hooks/API/useManageQuiz';
import useQuizClone from 'hooks/API/POST/useQuizClone';
import { VscSettingsGear } from 'react-icons/vsc';
import QuizSettings from './QuizSettings';
import useManageQuizSettings from 'hooks/API/useManageQuizSettings';
import { MdSwapCalls, MdPictureAsPdf } from 'react-icons/md';
import AssignTo from 'pages/manage-chapters/AssignTo';
import RatingHistory from './RatingHistory';
import { ROLES, underQcReview, underSeReview, underTutorReview } from 'utilities/constants';
import { LightTooltip } from 'components/Inputs/Buttons';
import { FetchContext } from 'context/FetchContext';
import { usePdfJob } from 'context/PdfJobContext';
import { buildQuizPdfJobSpec, buildChapterQuizPdfJobSpec } from 'services/quizPdfFlow';
import { notifier } from 'components/Toaster';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

export const keyMapper = {
  qb: 'question_bank',
  ncert: 'ncert_solutions',
  mock: 'mock_test',
  previous_year: 'previous_year',
  past_papers: 'past_papers',
};

function MainAssessPerform({ pageType }) {
  const { classID, courseID } = useParams();
  // const [params, setParams] = usePaginateDefaults();
  const [selectedChapter, handleSelectedChapter] = useState({});
  // const [showQuizAddingText, handleShowQuizAddingText] = useState(false);
  const [deleteSModal, handleDeleteSModal] = useState({ show: false, data: {} });
  const [chapterName, handleChapterName] = useState('');
  const [status, handleStatus] = useState('active');
  const [formErrors, setFormErrors] = useState([]);
  const [chapters, setChapters] = useState([]);
  const { userPermissions = {}, userInfo = {} } = useContext(UserContext);
  const [chapterCopyMode, setChapterCopyMode] = useState({ open: false, data: {} });
  const [activeTab, setActiveTab] = useState();

  // const { mutate: reorderChapter } = useReOrderChapter({ classID, courseID });
  const _reorder = useReOrderChapterQuiz({ courseID });
  // const { mutate: reorderTopic } = useReOrderTopic({ classID, courseID });
  const { isLoading: postingChapter, mutate, isError: postingError } = useChapterAdd();
  const _chapters = useChapters({
    enabled: !!activeTab,
    courseID,
    classID,
    configs: { params: { screen: `screen_${activeTab}`, apiVersion: 1, manager: 'list' } },
  });

  const [assignToModal, setAssignToModal] = useState({ open: false, data: {} });
  const { privateFetch: mainPrivateFetch } = useContext(FetchContext);
  const { addJob: mainAddJob } = usePdfJob();
  const [chapterPdfMenuAnchorEl, setChapterPdfMenuAnchorEl] = useState(null);
  const [chapterPdfMenuTarget, setChapterPdfMenuTarget] = useState(null);

  const { data, isLoading, isError } = _chapters;
  const { result = [] } = data?.data ?? {};
  const queryParams = useQueryParams();
  let toScroll = queryParams.get('chapter');
  let __highlightSection = queryParams.get('highlightSection');
  if (!toScroll) toScroll = queryParams.get('topic');
  if (!toScroll) toScroll = queryParams.get('topic');
  if (!toScroll) toScroll = queryParams.get('quiz');
  if (__highlightSection) toScroll = __highlightSection;

  function scrollToTestDiv() {
    const divElement = document.getElementById(toScroll);
    // console.log('🚀 ~ scrollToTestDiv ~ divElement:', divElement);
    if (!divElement) return;

    divElement.scrollIntoView({
      behavior: 'smooth',
      alignToTop: false,
      block: 'center',
      inline: 'nearest',
    });
    divElement.classList.add('highlighter');
  }
  useEffect(() => {
    setTimeout(() => {
      scrollToTestDiv(toScroll);
    }, 1000);
  }, [result]);

  useToaster(postingChapter, { type: postingError ? 'error' : 'success' });
  useEffect(() => {
    if (result?.length > 0) {
      const _result = result.map((x) => {
        if (x.quizzes && Object.keys(x.quizzes).length > 1) {
          for (const quizType in x.quizzes) {
            x.quizzes[quizType] = x.quizzes[quizType]?.map((z) => ({ ...z, id: getRandomUid() }));
          }
        }
        return x;
      });
      setChapters([].concat(_result));
    }
  }, [result]);

  useEffect(() => {
    if (selectedChapter?._id) {
      if (selectedChapter?.status) handleStatus(selectedChapter?.status);
      handleChapterName(selectedChapter?.name ?? '');
    }
  }, [selectedChapter]);

  function manageChapters(data, cb) {
    if (postingChapter) return;

    mutate(data, {
      onSuccess() {
        cb?.();
      },
    });
    closeSModal();
  }

  function closeSModal() {
    handleDeleteSModal({ show: false, data: {} });
    handleSelectedChapter({});
  }

  function handleSave(args = {}, cb) {
    setFormErrors([]);

    const data = {
      name: `${chapterName}`.trim(),
      courseID,
      classID,
      status,
      ...args,
    };

    const validation = manageChaptersSchema.validate(data, {
      abortEarly: false,
      allowUnknown: true,
    });

    if (validation?.error) {
      setFormErrors(validation.error?.details ?? []);
      return;
    }

    manageChapters?.(
      {
        ...data,
        chapterID: selectedChapter?._id,
        type: selectedChapter?._id ? 'UPDATE' : 'CREATE',
        ...args,
      },
      cb
    );

    clearData();
  }

  function clearData() {
    setFormErrors([]);

    handleChapterName('');
    handleStatus('active');
    handleSelectedChapter({});
  }

  function handleChapterReOrder() {
    const _chapters = chapters.map((x) => x._id);
    /// not applicable fo quiz
    //reorderChapter({ chapters: _chapters });
  }

  function handleTopicReOrder(chapter) {
    const _selectedChapter = chapters.find((x) => x._id === chapter._id);
    if (_reorder.isLoading) return;

    const selectedChapter = chapters.find((chapter) => chapter._id === _selectedChapter?._id);

    if (selectedChapter) {
      const chapterID = _selectedChapter?._id;
      const quizzes = selectedChapter?.quizzes[keyMapper[activeTab]] || [];
      const quizIds = quizzes.map((x) => x._id);
      if (pageType === 'perform') _reorder.mutate({ chapterID: 'perform', quizIds });
      if (pageType === 'assess') _reorder.mutate({ chapterID, quizIds });
    }
  }
  function getChapterQuizPdfBasePath(chapterId, category) {
    return `/v1/admin/chapters/${chapterId}/quiz-pdf/${category}`;
  }

  function queueChapterPdfExport(chapter) {
    const chapterId = chapter?._id;
    if (!chapterId) return;
    const category = keyMapper[activeTab];
    const chapterName = (chapter?.name || 'Chapter').trim() || 'Chapter';
    mainAddJob(
      buildChapterQuizPdfJobSpec({
        privateFetch: mainPrivateFetch,
        chapterId,
        category,
        chapterName,
        activeTab,
        startMode: 'start',
      })
    );
  }

  async function downloadChapterPdf(chapter) {
    const chapterId = chapter?._id;
    if (!chapterId) return false;
    const category = keyMapper[activeTab];
    const chapterName = (chapter?.name || 'Chapter').trim() || 'Chapter';
    const filename = getQuizPdfFilename(`${chapterName}_${category}`);
    try {
      const response = await mainPrivateFetch.get(
        `${getChapterQuizPdfBasePath(chapterId, category)}/download`,
        { responseType: 'blob' }
      );
      downloadPdfBlob(response.data, filename);
      notifier.success(`${chapterName} combined PDF downloaded successfully.`);
      return true;
    } catch (error) {
      if (error?.response?.status === 404)
        notifier.error('No PDF found. Please generate a PDF first.');
      else notifier.error('Failed to download PDF. Please try again.');
      return false;
    }
  }

  // quiz related
  const errors = checkForErrors(formErrors);

  const __currentTab = queryParams.get('currentTab');

  useEffect(() => {
    if (pageType && !__currentTab) setActiveTab(pageType === 'assess' ? 'qb' : 'mock');
    if (pageType === 'assess' && __currentTab) {
      if (__currentTab === 'past_papers') setActiveTab('past_papers');
      if (__currentTab === 'question_bank') setActiveTab('qb');
      if (__currentTab === 'ncert_solutions') setActiveTab('ncert');
    }
    if (pageType !== 'assess') {
      if (__currentTab === 'mock_test') setActiveTab('mock');
      if (__currentTab === 'previous_year') setActiveTab('previous_year');
    }
  }, [pageType, __currentTab]);

  function getTypeCssClass() {
    let text = '';
    pageType = pageType.trim();
    switch (pageType) {
      case 'assess':
        text = `___mquizzess ___assess ___assess__${activeTab}`;
        break;
      case pageType === 'perform':
        text = `___mquizzess ___perform ___perform__${activeTab}`;
        break;

      default:
        text = `___mquizzess __${activeTab}`;
        break;
    }
    return text;
  }
  const { key } = userInfo?.data ?? {};
  const isSE = key === ROLES.SUBJECT_EXPERT;
  const isAdmin = key === ROLES.ADMIN;
  const notTeacher = key !== ROLES.TUTOR;
  const isTeacher = key === ROLES.TUTOR;
  // quiz related
  return (
    <>
      {assignToModal.open && (
        <AssignTo
          open={assignToModal.open}
          closeModal={() => {
            setAssignToModal({ open: false, data: {} });
          }}
          data={{
            ...assignToModal.data,
            reviewOptions: userPermissions?.assess?.quiz?.reviewOptions ?? [],
          }}
          fns={{
            handleSave: (__data = {}) => {
              handleSave(__data, () => {
                setAssignToModal({ open: false, data: {} });
              });
            },
          }}
        />
      )}
      {chapterCopyMode.open && (
        <CopyContentsModal
          open={chapterCopyMode.open}
          closeModal={() => {
            setChapterCopyMode({ open: false, data: {} });
          }}
          data={chapterCopyMode.data}
        />
      )}
      <BasicDelete
        open={deleteSModal.show}
        closeModal={closeSModal}
        Header="Delete Chapter"
        handleConfirmation={() => {
          manageChapters({ ...(deleteSModal.data ?? {}), classID, type: 'DELETE' });
        }}
      />
      <div className="mainWraper ___chapterListing__module___cust___clas">
        {/* <div className="saved-flag changessave">
          <span className="green-check"></span>
          Changes Saved!
        </div> */}
        <div className="tab">
          <ul className="tab__menu">
            <li className="back">
              <Link to={`/courses/${courseID}/edit`}>
                <AppButton variantClass="btn-back">
                  <img src={AppPics.BackSvg} alt="" />
                </AppButton>
              </Link>
            </li>

            {pageType === 'assess' && (
              <li
                onClick={() => setActiveTab('qb')}
                className={`${activeTab === 'qb' ? 'active' : ''}`}
              >
                Question Bank
              </li>
            )}
            {pageType === 'assess' && (
              <li
                onClick={() => setActiveTab('ncert')}
                className={`${activeTab === 'ncert' ? 'active' : ''}`}
              >
                NCERT
              </li>
            )}
            {pageType === 'assess' && (
              <li
                onClick={() => setActiveTab('past_papers')}
                className={`${activeTab === 'past_papers' ? 'active' : ''}`}
              >
                Past papers
              </li>
            )}
            {pageType === 'perform' && (
              <li
                onClick={() => setActiveTab('mock')}
                className={`${activeTab === 'mock' ? 'active' : ''}`}
              >
                Mock Exams
              </li>
            )}
            {pageType === 'perform' && (
              <li
                onClick={() => setActiveTab('previous_year')}
                className={`${activeTab === 'previous_year' ? 'active' : ''}`}
              >
                Previous Years
              </li>
            )}
            {/* <li
              onClick={() => setActiveTab('cHistory')}
              className={`${activeTab === 'cHistory' ? 'active' : ''}`}
            >
              Rating History
            </li> */}
          </ul>

          <div className="tab__content ___adjust___tab___padding">
            <div className="tab__content-actHead">
              <DetailsHeader
                fromAssess={pageType === 'access'}
                fromPerform={pageType === 'perform'}
              />
            </div>

            <div className={`tab__content-actBody ${getTypeCssClass()}`}>
              <div className="px-5">
                {/* no need to add chapter from quizes page */}
                {false === true && (
                  <div className="row my-4">
                    <div className="col-12">
                      <div className="lessonWrap lessonWrap--border formfield">
                        <AppTextField
                          labelProps={{ label: 'Chapter Name' }}
                          inputProps={{
                            placeholder: userPermissions?.chapter?.canCreateNew
                              ? 'Enter chapter name here...'
                              : 'Sorry you dont have enough permission to add a chapter',
                            disabled: !userPermissions?.chapter?.canCreateNew,
                            value: chapterName,
                            onChange: (event) => handleChapterName(event.target.value),
                          }}
                          fieldErrors={errors['name']}
                        />
                        {
                          <AppButton
                            disabled={!userPermissions?.chapter?.canCreateNew}
                            variantClass="btn-plane p--tint m-l-btn my-4"
                            onClick={() =>
                              userPermissions?.chapter?.canCreateNew
                                ? handleSave()
                                : alert('You have not permitted to do this action.')
                            }
                          >
                            Add CHAPTER
                          </AppButton>
                        }
                      </div>
                    </div>
                  </div>
                )}
                {/* no need to add chapter from quizes page */}
                {isLoading ? (
                  'Loading...'
                ) : isError ? (
                  'Failed to load data'
                ) : pageType === 'assess' ? (
                  activeTab === 'cHistory' ? (
                    <RatingHistory results={chapters} />
                  ) : (
                    <ReactSortable
                      list={chapters}
                      setList={setChapters}
                      handle=".incorrectId"
                      onSort={userPermissions?.chapter?.canSortChapter && handleChapterReOrder}
                    >
                      {/* no need to sort chapter from quizes page */}
                      {chapters.map((item) => {
                        const anythingUnderQc = item?.quizzes?.[keyMapper[activeTab]]?.some?.(
                          (x) => x.status === 'qc_review'
                        );
                        const anythingUnderSe = item?.quizzes?.[keyMapper[activeTab]]?.some?.(
                          (x) => x.status === 'review'
                        );
                        const anythingUnderTeacher = item?.quizzes?.[keyMapper[activeTab]]?.some?.(
                          (x) => x.status === 'teacher_review'
                        );

                        return (
                          <div className="row mt-5 assess-quiz relative mge-qzzes" key={item._id}>
                            {pageType === 'perform' && (
                              <div className="__img_sttas">
                                {item.reviewStatusOfChapterQuizAsses === 'teacher_review' &&
                                  notTeacher && (
                                    <LightTooltip title={`Content Locked`} placement="right-end">
                                      <button role="navigation" className="btn_svg_container">
                                        <img src={AppPics.LockedContent} />
                                      </button>
                                    </LightTooltip>
                                  )}{' '}
                                {item.reviewStatusOfChapterQuizAsses === 'teacher_review' &&
                                  isTeacher && (
                                    <LightTooltip
                                      title={`Content Correction`}
                                      placement="right-end"
                                    >
                                      <button role="navigation" className="btn_svg_container">
                                        <img src={AppPics.ContentCorrection} />
                                      </button>
                                    </LightTooltip>
                                  )}{' '}
                                {item.reviewStatusOfChapterQuizAsses === 'review' &&
                                  notTeacher && (
                                    <LightTooltip
                                      title={`Content Correction`}
                                      placement="right-end"
                                    >
                                      <button role="navigation" className="btn_svg_container">
                                        <img src={AppPics.ContentCorrection} />
                                      </button>
                                    </LightTooltip>
                                  )}{' '}
                                {item.reviewStatusOfChapterQuizAsses === 'review' &&
                                  isTeacher && (
                                    <LightTooltip title={`Content Locked`} placement="right-end">
                                      <button role="navigation" className="btn_svg_container">
                                        <img src={AppPics.LockedContent} />
                                      </button>
                                    </LightTooltip>
                                  )}{' '}
                                {item.reviewStatusOfChapterQuizAsses === 'teacher_verified' && (
                                  <LightTooltip title={`Content Verified`} placement="right-end">
                                    <button role="navigation" className="btn_svg_container">
                                      <img src={AppPics.ContentVerified} />
                                    </button>
                                  </LightTooltip>
                                )}{' '}
                              </div>
                            )}
                            <div className="col-12">
                              <div className="saved lessonWrap--border p-0">
                                <div className="row bgltgreen level1">
                                  <div className="col-md-10 col-lg-10 col-sm-12">
                                    <div
                                      id={`${item._id}`}
                                      className={`lessonWrap saved lessonWrap--border ${
                                        userPermissions?.chapter?.canSortChapter
                                          ? 'chapterGrabHandleIDForQuiz'
                                          : '___noDrag'
                                      } `}
                                    >
                                      <ManageChapter
                                        data={{
                                          classID,
                                          __chapterCloneState: [
                                            chapterCopyMode,
                                            setChapterCopyMode,
                                          ],
                                          activeTab,
                                        }}
                                        chapter={item}
                                        fns={{
                                          handleDelete: (chapter) =>
                                            handleDeleteSModal({
                                              show: true,
                                              data: {
                                                courseID,
                                                classID,
                                                chapterID: chapter._id,
                                              },
                                            }),
                                        }}
                                        handleSave={(data = {}) => {
                                          if (postingChapter) return;

                                          const body = {
                                            courseID,
                                            classID,
                                            status,
                                            ...data,
                                          };
                                          mutate(body);
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-2 col-lg-2 col-sm-12 mt-2 my-auto _pcetnteefid">
                                    {(isSE || isAdmin) &&
                                      !anythingUnderTeacher &&
                                      !anythingUnderQc && (
                                        <AppButton
                                          variantClass="btn-plane p--tint m-l-btn"
                                          disabled={!userPermissions?.lesson?.canAddLesson}
                                          onClick={() => {
                                            if (!userPermissions?.lesson?.canAddLesson)
                                              alert(
                                                'You dont have sufficient permission to do this action.'
                                              );
                                            const _chapters = chapters.map((x) => {
                                              if (x._id === item._id) {
                                                // if (!x.quizzes[keyMapper[activeTab]]) {
                                                //   x.quizzes[keyMapper[activeTab]] = [];
                                                // }

                                                if (
                                                  activeTab === keyMapper.past_papers &&
                                                  x.quizzes[keyMapper[activeTab]]?.length > 0
                                                ) {
                                                  window.alert(
                                                    'Only 1 past papers can be added against a chapter!'
                                                  );
                                                  return x;
                                                }

                                                x.quizzes[keyMapper[activeTab]] =
                                                  x.quizzes[keyMapper[activeTab]]?.concat({
                                                    id: getRandomUid(),
                                                    name: '',
                                                  }) ?? [];
                                              }
                                              return x;
                                            });

                                            setChapters(_chapters);
                                          }}
                                        >
                                          {pageType === 'assess' &&
                                            activeTab === 'qb' &&
                                            `+ Q.Bank`}
                                          {pageType === 'assess' &&
                                            activeTab === 'ncert' &&
                                            `+ NCERT`}
                                          {pageType === 'assess' &&
                                            activeTab === 'past_papers' &&
                                            `+ P.Papers`}
                                        </AppButton>
                                      )}
                                    {pageType === 'assess' && (
                                      <AppButton
                                        onClick={() => {
                                          let __propsKey = '';
                                          if (keyMapper[activeTab] === 'question_bank')
                                            __propsKey = 'changeQBStatus';
                                          if (keyMapper[activeTab] === 'ncert_solutions')
                                            __propsKey = 'changeNcertStatus';
                                          if (keyMapper[activeTab] === 'past_papers')
                                            __propsKey = 'changePastPapersStatus';

                                          setAssignToModal({
                                            open: true,
                                            data: {
                                              apiInfo: {
                                                fromAssess: true,
                                                name: item.name,
                                                status: item.status,
                                                type: 'UPDATE',
                                                chapterID: item._id,
                                                key: item.key,
                                                quizCategory: keyMapper[activeTab],
                                              },

                                              reviewStatus: anythingUnderQc
                                                ? 'qc_review'
                                                : anythingUnderSe
                                                ? 'review'
                                                : anythingUnderTeacher
                                                ? 'teacher_review'
                                                : '',
                                              changeableStatus: item?.[__propsKey],

                                              contentOwner:
                                                item?.quizzes?.[keyMapper[activeTab]]?.[0]
                                                  ?.contentOwner,
                                              assignedTutorForReview:
                                                item?.quizzes?.[keyMapper[activeTab]]?.[0]
                                                  ?.assignedTutorForReview,

                                              visitedQuestions:
                                                item?.visitedQuestions?.[keyMapper[activeTab]]?.[
                                                  item._id
                                                ],
                                              ratedQuestions:
                                                item?.ratedQuestions?.[keyMapper[activeTab]]?.[
                                                  item._id
                                                ],
                                            },
                                          });
                                        }}
                                      >
                                        <MdSwapCalls
                                          color="#7e1f8c"
                                          fontSize={'22px'}
                                          style={{ verticalAlign: 'middle' }}
                                        />
                                      </AppButton>
                                    )}
                                    {pageType === 'assess' &&
                                      ['qb', 'ncert', 'past_papers'].includes(activeTab) && (
                                        <>
                                          <AppButton
                                            variantClass="lessonWrap__btn"
                                            title="Generate All PDFs"
                                            onClick={(e) => {
                                              setChapterPdfMenuTarget(item);
                                              setChapterPdfMenuAnchorEl(e.currentTarget);
                                            }}
                                          >
                                            <MdPictureAsPdf
                                              color="#7e1f8c"
                                              style={{ fontSize: '18px', verticalAlign: 'middle' }}
                                            />
                                          </AppButton>
                                          {chapterPdfMenuTarget?._id === item._id && (
                                            <Menu
                                              anchorEl={chapterPdfMenuAnchorEl}
                                              open={
                                                Boolean(chapterPdfMenuAnchorEl) &&
                                                chapterPdfMenuTarget?._id === item._id
                                              }
                                              onClose={() => {
                                                setChapterPdfMenuAnchorEl(null);
                                                setChapterPdfMenuTarget(null);
                                              }}
                                            >
                                              <MenuItem
                                                onClick={() => {
                                                  setChapterPdfMenuAnchorEl(null);
                                                  setChapterPdfMenuTarget(null);
                                                  queueChapterPdfExport(item);
                                                }}
                                              >
                                                Generate PDF
                                              </MenuItem>
                                              <MenuItem
                                                onClick={() => {
                                                  setChapterPdfMenuAnchorEl(null);
                                                  setChapterPdfMenuTarget(null);
                                                  downloadChapterPdf(item);
                                                }}
                                              >
                                                Download PDF
                                              </MenuItem>
                                            </Menu>
                                          )}
                                        </>
                                      )}
                                  </div>
                                </div>

                                <ReactSortable
                                  list={item?.quizzes?.[keyMapper[activeTab]] || []}
                                  setList={(newState) => {
                                    setChapters(
                                      chapters.map((x) => {
                                        if (item._id === x._id && item?.quizzes?.[keyMapper]) {
                                          item.quizzes[keyMapper[activeTab]] = newState;
                                        }
                                        return x;
                                      })
                                    );
                                  }}
                                  handle=".topicGrabHandleIDQuiz"
                                  onSort={() =>
                                    userPermissions?.lesson?.canSortLesson &&
                                    handleTopicReOrder(item)
                                  }
                                >
                                  {/* quiz sorting not needed as of now */}

                                  {item?.quizzes?.[keyMapper[activeTab]]?.map((topic, indeKey) => {
                                    return (
                                      <ManageLesson
                                        key={indeKey}
                                        data={{
                                          pageType,
                                          activeTab: keyMapper[activeTab],
                                          __chapterCloneState: [
                                            chapterCopyMode,
                                            setChapterCopyMode,
                                          ],
                                          changeMockStatus: item?.changeMockStatus,
                                          changePreviousYearStatus: item?.changePreviousYearStatus,
                                          visitedQuestions: item?.visitedQuestions,
                                          ratedQuestions: item?.ratedQuestions,
                                          isAdmin,
                                          isSE,
                                        }}
                                        selectedTopic={topic}
                                        chapterID={item._id}
                                        sortSubLessons={(newState, topicID) => {
                                          // setChapters(
                                          //   chapters.map((chapter) => {
                                          //     if (chapter._id === item._id) {
                                          //       chapter.topics = (chapter.topics || []).map((t) => {
                                          //         if (t._id === topicID) {
                                          //           t.subTopics = newState;
                                          //         }
                                          //         return t;
                                          //       });
                                          //     }
                                          //     return chapter;
                                          //   })
                                          // );
                                        }}
                                      />
                                    );
                                  })}
                                </ReactSortable>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </ReactSortable>
                  )
                ) : (
                  <>
                    {activeTab === 'cHistory' ? (
                      <RatingHistory results={chapters} />
                    ) : (
                      <>
                        {/* perform tab */}
                        <div className="col-md-2 col-lg-2 col-sm-12 mt-2 _pcetnteefid">
                          {(isSE || isAdmin) && (
                            <AppButton
                              variantClass="btn-plane p--tint m-l-btn"
                              disabled={!userPermissions?.lesson?.canAddLesson}
                              onClick={() => {
                                if (!userPermissions?.lesson?.canAddLesson) {
                                  alert('You dont have sufficient permission to do this action.');
                                  return;
                                } else {
                                  //handleShowQuizAddingText(!showQuizAddingText);
                                  const _chapters = chapters.map((x, chapterPos) => {
                                    if (chapterPos === 0) {
                                      if (!x.quizzes[keyMapper[activeTab]]) {
                                        x.quizzes[keyMapper[activeTab]] = [];
                                      }
                                      x.quizzes[keyMapper[activeTab]] =
                                        x.quizzes[keyMapper[activeTab]]?.concat({
                                          id: getRandomUid(),
                                          name: '',
                                        }) ?? [];
                                    }

                                    return x;
                                  });
                                  setChapters(_chapters);
                                }
                              }}
                            >
                              {pageType === 'perform' && activeTab === 'mock' && `+ Mock`}
                              {pageType === 'perform' &&
                                activeTab === 'previous_year' &&
                                `+ P.Years`}
                            </AppButton>
                          )}
                        </div>
                        <div className="row mt-5 perform-quiz">
                          <div className="col-12">
                            <ReactSortable
                              list={chapters[0]?.quizzes?.[keyMapper[activeTab]] || []}
                              setList={(newState) => {
                                setChapters(
                                  chapters.map((x) => {
                                    if (chapters[0].quizzes && chapters[0].quizzes[keyMapper]) {
                                      chapters[0].quizzes[keyMapper[activeTab]] = newState;
                                    }
                                    return x;
                                  })
                                );
                              }}
                              //handle=".nonExitingId_perform"
                              handle=".topicGrabHandleIDQuiz"
                              onSort={() =>
                                //{}
                                userPermissions?.lesson?.canSortLesson &&
                                handleTopicReOrder(chapters[0])
                              }
                            >
                              {/* quiz sorting not needed as of now */}

                              {(chapters[0]?.quizzes?.[keyMapper[activeTab]] || [])?.map(
                                (topic, indeKey) => {
                                  return (
                                    <ManageLesson
                                      key={indeKey}
                                      data={{
                                        pageType,
                                        activeTab: keyMapper[activeTab],
                                        __chapterCloneState: [chapterCopyMode, setChapterCopyMode],
                                        visitedQuestions: chapters[0]?.visitedQuestions,
                                        ratedQuestions: chapters[0]?.ratedQuestions,
                                        isAdmin,
                                        isSE,
                                      }}
                                      selectedTopic={topic}
                                      chapterID={''}
                                      sortSubLessons={(e) => {}}
                                      // sortSubLessons={(newState, topicID) => {
                                      //   setChapters(
                                      //     chapters.map((chapter) => {
                                      //       if (chapter._id === item._id) {
                                      //         chapter.topics = (chapter.topics || []).map((t) => {
                                      //           if (t._id === topicID) {
                                      //             t.subTopics = newState;
                                      //           }
                                      //           return t;
                                      //         });
                                      //       }
                                      //       return chapter;
                                      //     })
                                      //   );
                                      // }}
                                    />
                                  );
                                }
                              )}
                            </ReactSortable>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
            </div>

            {/* <TablePaginate
              maxCount={total}
              currentPage={page}
              defaultLimit={params.limit}
              setPage={(page) => setParams((x) => ({ ...x, page }))}
              handleChange={(limit) => setParams((x) => ({ ...x, page: 0, limit }))}
            /> */}
          </div>
        </div>
      </div>
    </>
  );
}

const manageChaptersSchema = Joi.object({
  name: Joi.string().required().trim(),
  status: Joi.string().required(),
});

function ManageChapter({ chapter, handleSave, fns = {}, data = {} }) {
  const { userPermissions = {}, userInfo = {} } = useContext(UserContext);
  const { classID, __chapterCloneState = [], activeTab } = data;
  const { handleDelete } = fns;
  const [editMode, setEditMode] = useState(false);
  const [chapterCopyMode, setChapterCopyMode] = __chapterCloneState;
  const [chapterName, setChapterName] = useState('');
  const { key } = userInfo?.data ?? {};

  const { mutate, isLoading, isError } = useCloneChapter({ classID });

  useToaster(isLoading, { type: isError ? 'error' : 'success' });

  useEffect(() => {
    setChapterName(chapter.name || '');
  }, [chapter.name]);

  function save(body = {}) {
    if (!chapterName) {
      setChapterName(chapter.name || '');
      setEditMode(!editMode);
      return;
    }

    handleSave({
      type: 'UPDATE',
      name: `${chapterName}`.trim(),
      chapterID: chapter._id,
      key: chapter.key,
      ...body,
    });
    // setEditMode(!editMode);
    setEditMode(false);
  }

  function cloneChapter() {
    if (isLoading) return;
    if (!chapter._id) return;

    const data = { chapters: [chapter._id] };
    mutate(data);
  }

  return (
    <>
      <div className="lessonWrap__text">
        {!editMode && (
          <span className="lessonWrap__name">
            {chapter.name}{' '}
            {chapter?.quizzes?.[keyMapper[activeTab]]?.some?.((q) => q.status === 'qc_review') && (
              <span class="badge badge-danger vetting-cases">
                <img src={AppPics.TutorVettingEyeSVG} alt="" />
                {underQcReview}
              </span>
            )}
            {chapter?.quizzes?.[keyMapper[activeTab]]?.some?.((q) => q.status === 'review') && (
              <span class="badge badge-danger vetting-cases">
                <img src={AppPics.TutorVettingEyeSVG} alt="" />
                {underSeReview}
              </span>
            )}
            {chapter?.quizzes?.[keyMapper[activeTab]]?.some?.(
              (q) => q.status === 'teacher_review'
            ) && (
              <span class="badge badge-danger vetting-cases teacher-vetting">
                <img src={AppPics.TutorVettingEyeSVG} alt="" />
                {underTutorReview}
              </span>
            )}
          </span>
        )}
        {true === false && (
          <>
            {' '}
            {editMode && (
              <input
                type="text"
                value={chapterName}
                disabled={!userPermissions?.chapter?.canEditInfo}
                onChange={(event) =>
                  userPermissions?.chapter?.canEditInfo && setChapterName(event.target.value)
                }
              />
            )}
            {!editMode && (
              <AppButton
                variantClass="lessonWrap__btn"
                disabled={!userPermissions?.chapter?.canEditInfo}
                onClick={() => userPermissions?.chapter?.canEditInfo && setEditMode(!editMode)}
                title="Edit"
              >
                <img src={AppPics.EditSvg} alt="" />
              </AppButton>
            )}
            {editMode && (
              <AppButton
                disabled={!userPermissions?.chapter?.canEditInfo}
                variantClass="lessonWrap__btn"
                onClick={() => userPermissions?.chapter?.canEditInfo && save()}
                title="Save"
              >
                <img src={AppPics.CheckSvg} alt="" />
              </AppButton>
            )}
            {true && (
              <AppButton
                variantClass="lessonWrap__btn"
                title="Copy"
                onClick={() => {
                  setChapterCopyMode({ open: true, data: { chapterID: chapter._id, classID } });
                }}
              >
                <img src={AppPics.CopySvg} alt="" />
              </AppButton>
            )}
            <AppButton
              variantClass="lessonWrap__btn"
              title="Clone"
              disabled={!userPermissions?.chapter?.canDuplicateChapter}
              onClick={() => userPermissions?.chapter?.canDuplicateChapter && cloneChapter()}
            >
              <img src={AppPics.StampSvg} alt="Clone" />
            </AppButton>
            {chapter.status === 'hide' && (
              <AppButton
                variantClass="lessonWrap__btn"
                disabled={!userPermissions?.chapter?.canHideChapter}
                onClick={() => {
                  if (userPermissions?.chapter?.canHideChapter) {
                    save({ status: 'active' });
                  }
                }}
              >
                <img src={AppPics.ViewStrikeSvg} alt="Hide/View chapter" />
              </AppButton>
            )}
            {chapter.status === 'active' && (
              <AppButton
                variantClass="lessonWrap__btn"
                disabled={!userPermissions?.chapter?.canHideChapter}
                onClick={() => {
                  if (userPermissions?.chapter?.canHideChapter) {
                    save({ status: 'hide' });
                  }
                }}
              >
                <AiOutlineEye
                  style={{ color: '#7e1f8c', fontSize: '22px', verticalAlign: 'middle' }}
                />
              </AppButton>
            )}
            <AppButton
              variantClass="lessonWrap__btn"
              disabled={!userPermissions?.chapter?.canDeleteChapter}
              onClick={() => userPermissions?.chapter?.canDeleteChapter && handleDelete(chapter)}
              title="Delete"
            >
              <img src={AppPics.TrashBinSvg} alt="" />
            </AppButton>
          </>
        )}
      </div>
    </>
  );
}

// ── Quiz PDF helpers ──────────────────────────────────────────────────────

const QUIZ_PDF_POLL_MS = 2000;
const QUIZ_PDF_POLL_TIMEOUT_MS = 45 * 60 * 1000;

const getQuizPdfBasePath = ({ quizId }) => `/v1/admin/quiz/${quizId}/pdf`;

const getQuizPdfFilename = (quizName = 'Quiz') => `${quizName.replace(/\s+/g, '_')}.pdf`;

const getResponseData = (response = {}) => response?.data?.data || response?.data || {};

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

async function pollQuizPdfGeneration({
  privateFetch,
  quizId,
  onProgress,
  isCancelled,
  cancelOnServer,
  signal,
}) {
  const startedAt = Date.now();
  while (true) {
    if (isCancelled()) {
      await cancelOnServer?.();
      throw new Error('PDF job cancelled');
    }
    if (Date.now() - startedAt > QUIZ_PDF_POLL_TIMEOUT_MS) {
      throw new Error('This is taking longer than expected. You can try downloading later.');
    }
    await wait(QUIZ_PDF_POLL_MS);
    if (isCancelled()) {
      await cancelOnServer?.();
      throw new Error('PDF job cancelled');
    }
    let statusData;
    try {
      const response = await privateFetch.get(`${getQuizPdfBasePath({ quizId })}/status`, {
        signal,
      });
      statusData = getResponseData(response);
    } catch (error) {
      if (error?.response?.status === 404)
        return { hasPdf: false, status: 'not_found', progress: 0 };
      // Transient network errors (python-pdf-app restart, gateway timeout, etc.)
      // shouldn't kill the job — server may still be processing it.
      continue;
    }
    const normalizedStatus = String(statusData?.status || '').toLowerCase();
    onProgress(Number(statusData?.progress || 0));
    if (normalizedStatus === 'completed') return statusData;
    if (normalizedStatus === 'failed' || normalizedStatus === 'not_found') {
      throw new Error('PDF generation failed. Please try again.');
    }
  }
}

function downloadPdfBlob(blobData, filename) {
  const blob =
    blobData instanceof Blob ? blobData : new Blob([blobData], { type: 'application/pdf' });
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 5000);
}

// ─────────────────────────────────────────────────────────────────────────────

function ManageLesson({ chapterID, selectedTopic = {}, data = {} }) {
  const { _id: topicID, name: usedTopicName, subTopics = [] } = selectedTopic;
  const { userPermissions = {} } = useContext(UserContext);
  const { privateFetch } = useContext(FetchContext);
  const { classID, courseID } = useParams();
  const [topicName, setQuizName] = useState('');
  const [editMode, setEditMode] = useState(false);
  const [deleteSModal, handleDeleteSModal] = useState({ show: false, data: {} });
  const [settingsModal, setSettingsModal] = useState({ show: false, data: {} });
  const { __chapterCloneState = [], activeTab, pageType, ratedQuestions } = data;
  const { changeMockStatus, changePreviousYearStatus, visitedQuestions, isAdmin, isSE } = data;

  const [chapterCopyMode, setChapterCopyMode] = __chapterCloneState;

  const [subTopicName, setSubTopicName] = useState('');
  const [addSubTopicView, setAddSubTopicView] = useState(false);

  const [assignToModal, setAssignToModal] = useState({ open: false, data: {} });

  const { addJob } = usePdfJob();
  const [quizPdfMenuAnchorEl, setQuizPdfMenuAnchorEl] = useState(null);

  const { mutate, isLoading, isError } = useManageTopics({ classID, courseID, chapterID });
  const { mutate: clone, isLoading: loading, isError: err } = useQuizClone({ courseID });

  const _subtopics = useManageSubTopics({ classID, courseID, chapterID, topicID });
  const { mutate: createSubTopic, isLoading: isUpdating } = _subtopics;
  const _reOrder = useReOrderSubTopics({ classID, courseID, chapterID, topicID });
  const { mutate: reOrder, isLoading: reordering } = _reOrder;
  const {
    isLoading: quizActionLoading,
    mutate: quizActionMutate,
    isError: quizActionError,
  } = useManageQuiz();

  const cb = useCallback(
    function toasterConfig() {
      if (loading) return [loading, { type: err ? 'error' : 'success' }];
      if (isLoading) return [isLoading, { type: isError ? 'error' : 'success' }];
      return [];
    },
    [err, isError, isLoading, loading]
  );

  useToaster(...cb());

  useEffect(() => {
    if (usedTopicName) setQuizName(usedTopicName);
  }, [usedTopicName]);

  function handleQuiz(args = {}, cb) {
    if (!topicName) return;
    if (isLoading) return;

    const quizFormData = {
      class: classID,
      course: courseID,
      chapter: chapterID,
      name: `${topicName}`.trim(),
      quizCategory: activeTab,
      status: 'draft',
      ...args,
    };
    if (topicID) quizFormData.type = 'UPDATE';
    if (topicID) quizFormData.id = topicID;

    if (['mock_test', 'previous_year'].includes(activeTab)) {
      quizFormData.papers = [{ value: 'Paper 1' }, { value: 'Paper 2' }, { value: 'Paper 3' }];
      quizFormData.sections = [
        { value: 'Section A' },
        { value: 'Section B' },
        { value: 'Section C' },
        { value: 'Section D' },
        { value: 'Section E' },
      ];
    }

    quizActionMutate(quizFormData, {
      onSuccess() {
        setEditMode(false);
        cb?.();
      },
    });
    // setEditMode(!editMode);
  }

  function manageSubTopic() {
    if (!subTopicName) return;
    if (isUpdating) return;

    const data = { name: `${subTopicName}`.trim() };
    createSubTopic(data);
  }

  function handleClone(apiBody = {}) {
    if (!topicName) return;
    if (!topicID) return;
    if (loading) return;

    clone(apiBody);
  }

  function deleteTopic(topicId) {
    if (isLoading) return;
    //deleteQuiz;
    quizActionMutate({ type: 'DELETE', topicID: topicId });
  }

  function handleSubTopicSort() {
    if (reordering) return;

    reOrder({ subTopics: subTopics.map((x) => `${x._id}`) });
  }
  let qLink = `/classes/${classID}/courses/${courseID}/chapters/${chapterID}/quizzes/${topicID}/questions/add?screen=screen_${activeTab}&topicId=${topicID}`;
  let isPerformPage = false;
  const isPdfPage = [
    'mock_test',
    'previous_year',
    'question_bank',
    'ncert_solutions',
    'past_papers',
  ].includes(activeTab);

  if (['mock_test', 'previous_year'].includes(activeTab)) {
    isPerformPage = true;
    qLink = `/classes/${classID}/courses/${courseID}/quizzes/${topicID}/questions/add?tab=perform&screen=screen_${activeTab}&topicId=${topicID}`;
  }

  function queueQuizPdfExport() {
    if (!topicID) return;
    const safeQuizName = (topicName || 'Quiz').trim() || 'Quiz';
    addJob(
      buildQuizPdfJobSpec({
        privateFetch,
        quizId: topicID,
        quizName: safeQuizName,
        startMode: 'start',
      })
    );
  }

  async function downloadQuizPdf() {
    if (!topicID) return false;
    const safeQuizName = (topicName || 'Quiz').trim() || 'Quiz';
    const filename = getQuizPdfFilename(safeQuizName);
    try {
      const response = await privateFetch.get(
        `${getQuizPdfBasePath({ quizId: topicID })}/download`,
        { responseType: 'blob' }
      );
      downloadPdfBlob(response.data, filename);
      notifier.success(`${safeQuizName} PDF downloaded successfully.`);
      return true;
    } catch (error) {
      if (error?.response?.status === 404) {
        notifier.error('No PDF found. Please generate a PDF first.');
      } else {
        notifier.error('Failed to download PDF. Please try again.');
      }
      return false;
    }
  }

  const __r = pageType === 'perform' && (
    <>
      {selectedTopic?.reviewStatusOfQuiz === 'qc_review' && (
        <span class="badge badge-danger vetting-cases teacher-vetting">
          <img src={AppPics.TutorVettingEyeSVG} alt="" />
          {underQcReview}
        </span>
      )}
      {selectedTopic?.reviewStatusOfQuiz === 'review' && (
        <span class="badge badge-danger vetting-cases teacher-vetting">
          <img src={AppPics.TutorVettingEyeSVG} alt="" />
          {underSeReview}
        </span>
      )}

      {selectedTopic?.reviewStatusOfQuiz === 'teacher_review' && (
        <span class="badge badge-danger vetting-cases teacher-vetting">
          <img src={AppPics.TutorVettingEyeSVG} alt="" />
          {underTutorReview}
        </span>
      )}
    </>
  );

  return (
    <>
      {assignToModal.open && (
        <AssignTo
          open={assignToModal.open}
          closeModal={() => {
            setAssignToModal({ open: false, data: {} });
          }}
          data={{
            ...assignToModal.data,
            reviewOptions: userPermissions?.perform?.quiz?.reviewOptions ?? [],
          }}
          fns={{
            handleSave: (data = {}) =>
              handleQuiz(data, () => {
                setAssignToModal({ open: false, data: {} });
              }),
          }}
        />
      )}
      <BasicDelete
        open={deleteSModal.show}
        closeModal={() => handleDeleteSModal({ show: false, data: {} })}
        Header="Delete Quiz"
        Body="Do you want to delete this quiz?"
        handleConfirmation={() => {
          deleteTopic(deleteSModal?.data?._id);
          handleDeleteSModal({ show: false, data: {} });
        }}
      />
      {settingsModal.show && (
        <QuizSettings
          open={settingsModal.show}
          data={settingsModal.data}
          closeModal={() => setSettingsModal({ show: false, data: {} })}
          canSave={isAdmin || isSE}
        />
      )}
      <div className="row m-4">
        <div className="col-md-10 col-lg-10 col-sm-12 level-down-1">
          <div
            className={`lessonWrap lessonWrap--border ${
              userPermissions?.lesson?.canSortLesson ? 'topicGrabHandleIDQuiz' : '___noDrag'
            }`}
            id={`${topicID}`}
          >
            <div className="__img_sttas lzeonqu">
              {selectedTopic?.status === 'teacher_verified' && (
                <>
                  <LightTooltip title={`Content Verified`} placement="right-end">
                    <button role="navigation" className="btn_svg_container">
                      <img src={AppPics.ContentVerified} />
                    </button>
                  </LightTooltip>
                </>
              )}
              {isPerformPage && selectedTopic?.reviewStatusOfQuiz === 'teacher_verified' && (
                <>
                  <LightTooltip title={`Content Verified`} placement="right-end">
                    <button role="navigation" className="btn_svg_container">
                      <img src={AppPics.ContentVerified} />
                    </button>
                  </LightTooltip>
                </>
              )}
            </div>
            {topicID && (
              <div className="lessonWrap__text">
                {!editMode && (
                  <>
                    {!Array.isArray(selectedTopic?.papers) ||
                    selectedTopic?.papers?.length === 0 ? (
                      <Link
                        className="lessonWrap__name"
                        to={`${qLink}`}
                        //to={`/classes/${classID}/courses/${courseID}/chapters/${chapterID}/topics/${topicID}`}
                      >
                        <span>
                          {topicName} {__r}
                        </span>
                      </Link>
                    ) : (
                      <span className="lessonWrap__name">
                        {topicName} {__r}
                      </span>
                    )}
                  </>
                )}
                {editMode && (
                  <input
                    type="text"
                    value={topicName}
                    onChange={(event) => setQuizName(event.target.value)}
                  />
                )}
                {(isAdmin || isSE) && !editMode && (
                  <AppButton
                    variantClass="lessonWrap__btn"
                    title="Edit"
                    onClick={() => setEditMode(!editMode)}
                  >
                    <img src={AppPics.EditSvg} alt="" />
                  </AppButton>
                )}
                {editMode && (
                  <AppButton
                    variantClass="lessonWrap__btn"
                    title="Save"
                    onClick={() => handleQuiz()}
                  >
                    <img src={AppPics.CheckSvg} alt="" />
                  </AppButton>
                )}
                {pageType === 'perform' && (
                  <AppButton
                    variantClass="lessonWrap__btn"
                    onClick={() => {
                      const anythingUnderQc = selectedTopic?.reviewStatusOfQuiz === 'qc_review';
                      const anythingUnderSe = selectedTopic?.reviewStatusOfQuiz === 'review';
                      const anythingUnderTeacher =
                        selectedTopic?.reviewStatusOfQuiz === 'teacher_review';

                      const changeableStatus =
                        activeTab === 'mock_test'
                          ? changeMockStatus
                          : activeTab === 'previous_year'
                          ? changePreviousYearStatus
                          : undefined;

                      setAssignToModal({
                        open: true,
                        data: {
                          apiInfo: { fromPerform: true, quizCategory: activeTab },
                          reviewStatus: anythingUnderQc
                            ? 'qc_review'
                            : anythingUnderSe
                            ? 'review'
                            : anythingUnderTeacher
                            ? 'teacher_review'
                            : '',
                          changeableStatus,
                          contentOwner: selectedTopic?.contentOwner,
                          assignedTutorForReview: selectedTopic?.assignedTutorForReview,
                          visitedQuestions: visitedQuestions?.[activeTab]?.[selectedTopic?._id],
                          ratedQuestions: ratedQuestions?.[activeTab]?.[selectedTopic?._id],
                        },
                      });
                    }}
                  >
                    <MdSwapCalls
                      color="#7e1f8c"
                      fontSize={'22px'}
                      style={{ verticalAlign: 'middle' }}
                    />
                  </AppButton>
                )}
                {isAdmin ||
                  (isSE && (
                    <AppButton
                      variantClass="lessonWrap__btn"
                      title="Copy"
                      onClick={() => {
                        setChapterCopyMode({
                          open: true,
                          data: {
                            classID,
                            courseID,
                            isAssess: pageType === 'assess',
                            isPerform: pageType === 'perform',
                            quizId: topicID,
                            quizFormat: activeTab,
                          },
                        });
                      }}
                    >
                      <img src={AppPics.CopySvg} alt="" />
                    </AppButton>
                  ))}

                {isAdmin ||
                  (isSE && (
                    <AppButton
                      variantClass="lessonWrap__btn"
                      title="Clone"
                      disabled={activeTab === keyMapper.past_papers}
                      onClick={() => {
                        if (activeTab === keyMapper.past_papers) return;

                        const __data = {
                          classID,
                          courses: [courseID],
                          isAssess: pageType === 'assess',
                          isPerform: pageType === 'perform',
                          quizId: topicID,
                        };

                        if (pageType === 'assess') __data.chapters = [chapterID];

                        handleClone(__data);
                      }}
                    >
                      <img src={AppPics.StampSvg} alt="" />
                    </AppButton>
                  ))}

                {(isAdmin || isSE) && (
                  <AppButton
                    variantClass="lessonWrap__btn"
                    title="Delete"
                    onClick={() => handleDeleteSModal({ show: true, data: { _id: topicID } })}
                  >
                    <img src={AppPics.TrashBinSvg} alt="" />
                  </AppButton>
                )}

                <AppButton
                  variantClass="lessonWrap__btn"
                  title="Settings"
                  onClick={() => {
                    if (selectedTopic.isQuizUnderReview) return;

                    setSettingsModal({
                      show: true,
                      data: {
                        isPerform: pageType === 'perform',
                        activeTab,
                        quizId: topicID,
                        preFilledSettings: {
                          guidelines: selectedTopic.guidelines,
                          papers: selectedTopic.papers,
                          sections: selectedTopic.sections,
                          examBoard: selectedTopic.examBoard,
                          askedInYear: selectedTopic.askedInYear,
                        },
                      },
                    });
                  }}
                  style={selectedTopic.isQuizUnderReview ? { cursor: 'not-allowed' } : {}}
                >
                  <VscSettingsGear
                    color="#7e1f8c"
                    style={{ fontSize: '18px', verticalAlign: 'middle' }}
                  />
                </AppButton>
                {isPdfPage && (
                  <>
                    <AppButton
                      variantClass="lessonWrap__btn"
                      title="Quiz PDF"
                      onClick={(e) => setQuizPdfMenuAnchorEl(e.currentTarget)}
                    >
                      <MdPictureAsPdf
                        color="#7e1f8c"
                        style={{ fontSize: '18px', verticalAlign: 'middle' }}
                      />
                    </AppButton>
                    <Menu
                      anchorEl={quizPdfMenuAnchorEl}
                      open={Boolean(quizPdfMenuAnchorEl)}
                      onClose={() => setQuizPdfMenuAnchorEl(null)}
                    >
                      <MenuItem
                        onClick={() => {
                          setQuizPdfMenuAnchorEl(null);
                          queueQuizPdfExport();
                        }}
                      >
                        Generate PDF
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          setQuizPdfMenuAnchorEl(null);
                          downloadQuizPdf();
                        }}
                      >
                        Download PDF
                      </MenuItem>
                    </Menu>
                  </>
                )}
                {/* {(!Array.isArray(selectedTopic?.papers) || selectedTopic?.papers?.length === 0) && (
                  <Link
                    to={`${qLink}`}
                  >
                    <AppButton variantClass="lessonWrap__btn" title="Go to">
                      <img src={AppPics.LinkSvg} alt="" />
                    </AppButton>
                  </Link>
                )} */}
              </div>
            )}
            {!topicID && (
              <>
                <AppTextField
                  labelProps={{ label: 'Name' }}
                  inputProps={{
                    placeholder: 'Add name here...',
                    value: topicName,
                    onChange: (event) => setQuizName(event.target.value),
                  }}
                />
                <AppButton
                  variantClass="btn-plane p--tint m-l-btn my-4"
                  onClick={() => handleQuiz()}
                >
                  Save
                </AppButton>
              </>
            )}
          </div>
          {/* BEGIN: LOOP SUB LESSONS HERE sublesson not needed for quiz */}
          {/* <ReactSortable
            list={subTopics}
            setList={(newState) => sortSubLessons(newState, topicID)}
            handle=".subtopicGrabHandleID"
            onSort={userPermissions?.subLesson?.canSortSubLesson && handleSubTopicSort}
          > */}
          {selectedTopic?.papers?.map((paper) => {
            return (
              <QuizPapers
                key={paper?._id}
                paper={paper}
                selectedTopic={selectedTopic}
                qLink={qLink + (isPerformPage ? `&paperId=${paper._id}` : `?paperId=${paper._id}`)}
                displayBtns={isAdmin || isSE}
              />
            );
          })}
          {/* </ReactSortable> */}
          {/* END: LOOP SUB LESSONS HERE */}

          {/* BEGIN: ADD SUB LESSON INPUT HERE sublesson not needed for quiz  */}
          {addSubTopicView && false === true && (
            <div className="row mt-4">
              <div className="offset-1 col-11">
                <div className="lessonWrap lessonWrap--border formfield">
                  <AppTextField
                    labelProps={{ label: 'Sub Lesson Name' }}
                    inputProps={{
                      placeholder: userPermissions?.subLesson?.canAddSubLesson
                        ? 'Add sub lesson name here...'
                        : 'You dont have sufficient permission to add a sub lesson',
                      value: subTopicName,
                      onChange: (event) =>
                        userPermissions?.subLesson?.canAddSubLesson &&
                        setSubTopicName(event.target.value),
                    }}
                  />
                </div>
                <AppButton
                  disabled={!userPermissions?.subLesson?.canAddSubLesson}
                  variantClass="btn-plane p--tint m-l-btn my-4"
                  onClick={() => userPermissions?.subLesson?.canAddSubLesson && manageSubTopic()}
                >
                  Save sub lesson
                </AppButton>
              </div>
            </div>
          )}
          {/* END: ADD SUB LESSON INPUT HERE */}
        </div>
        {/* <div className="col-md-2 col-lg-2 col-sm-12">
          <AppButton
            variantClass="btn-plane p--tint"
            disabled={!userPermissions?.subLesson?.canAddSubLesson}
            onClick={() => userPermissions?.subLesson?.canAddSubLesson && setAddSubTopicView(true)}
          >
            ++ SUB LESSON
          </AppButton>
        </div> */}
      </div>
    </>
  );
}

function QuizPapers({ paper, qLink, selectedTopic, displayBtns }) {
  const [editMode, setEditMode] = useState(false);
  const [paperName, setPaperName] = useState('');

  const { isLoading, mutate } = useManageQuizSettings({ quizId: selectedTopic?._id });

  useEffect(() => {
    setPaperName(paper.value || '');
  }, [paper.value]);

  function handleSubmit(__data) {
    if (!editMode) return;
    if (isLoading) return;

    const { guidelines, sections, papers } = selectedTopic;

    mutate(
      {
        guidelines,
        papers: papers?.map?.((p) => {
          if (p?._id === __data?._id) p.value = paperName;

          return p;
        }),
        sections,
      },
      {
        onSettled() {
          setEditMode(false);
        },
      }
    );
  }

  return (
    <div className="row mt-4">
      <div className="offset-1 col-11">
        <div className="p-4 lessonWrap--border" id={`${paper._id}`}>
          <div className="lessonWrap__text sample456">
            {!editMode && (
              <Link className="lessonWrap__name" to={`${qLink}`}>
                <span>{paper.value}</span>
              </Link>
            )}
            {editMode && (
              <input
                type="text"
                value={paperName}
                onChange={(event) => setPaperName(event.target.value)}
              />
            )}
            {displayBtns && !editMode && (
              <AppButton
                variantClass="lessonWrap__btn"
                title="Edit"
                onClick={() => setEditMode(!editMode)}
              >
                <img src={AppPics.EditSvg} alt="" />
              </AppButton>
            )}
            {displayBtns && editMode && (
              <AppButton
                variantClass="lessonWrap__btn"
                title="Save"
                onClick={() => {
                  handleSubmit(paper);
                }}
              >
                <img src={AppPics.CheckSvg} alt="" />
              </AppButton>
            )}
            {/* <Link to={`${qLink}`}>
              <AppButton variantClass="lessonWrap__btn" title="Go to">
                <img src={AppPics.LinkSvg} alt="" />
              </AppButton>
            </Link> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainAssessPerform;
